// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--YPEX4","btn":"a10a3f92e9--btn--kKxuW","icon":"a10a3f92e9--icon--p_zPh","arrow":"a10a3f92e9--arrow--dSeHF","texts":"a10a3f92e9--texts--nXnnq"};